import SideBySideRecordsTable from "./SideBySideRecordsTable";
import PageMeta from "./PageMeta";

export default function JuniorCatchReleasePage() {
  return (
    <>
      <PageMeta
        title="RSAA Junior Catch & Release Records | Redruth Sea Angling Association"
        description="Junior catch and release records for Redruth Sea Angling Association, celebrating young Cornish sea anglers' best catches returned safely to the sea."
        keywords="junior catch and release records, RSAA junior anglers, young sea anglers Cornwall"
        url="https://www.redruthseaanglingassociation.co.uk/junior-catch-release"
      />
      <SideBySideRecordsTable
        title="RSAA Junior Catch & Release Records"
        excelFile="/rsaa_catch_rlease_record.xlsx"
        recordType="catchAndRelease"
        scope="junior"
      />
    </>
  );
}
